import React from 'react';
import { observer } from 'mobx-react';
import { useTheme } from 'styled-components';

import { ModalStep } from '@components/common/multiStepModal';
import { BaseText } from '@ui-library/typography';
import { Flex } from '@ui-library/flex';
import { useDeleteAccounts } from '@components/common/accountManagement/hooks/dataUpdater';
import { useMultiStepModalStore } from '@components/common/multiStepModal/modalStore';

import { useAccountManagementStore } from '../../store';
import { AccountDetails } from '../accountDetails';
import { useDesignVariant } from '../../designVariantContext';

export const DeleteAccountConfirmationModalStep: React.FC = observer(() => {
  const theme = useTheme();
  const accountManagementStore = useAccountManagementStore();
  const { selectedDeleteAccountId, resourceDefinitionName } = accountManagementStore;
  const multiStepModalStore = useMultiStepModalStore();
  const [loading, setLoading] = React.useState(false);

  const isNext = useDesignVariant() === 'next';

  const deleteAccounts = useDeleteAccounts();

  const handleDeleteClick = async () => {
    setLoading(true);
    const successful = await deleteAccounts(selectedDeleteAccountId, resourceDefinitionName);

    if (successful) {
      multiStepModalStore.prev();
    }

    setLoading(false);
  };

  return (
    <ModalStep
      gap="32px"
      header={{
        title: 'Delete account?',
        description: 'This will permanently delete your account',
      }}
      footer={{
        actionButton: {
          text: 'Delete account',
          danger: true,
          intent: 'destructive',
          onClick: handleDeleteClick,
        },
        dismissButton: {
          visible: false,
        },
        loading,
      }}
    >
      <AccountDetails store={accountManagementStore} accountId={selectedDeleteAccountId} />
      <Flex flexDirection="column" gap="4px">
        <BaseText
          fontWeight={isNext ? undefined : 600}
          color={isNext ? theme.token.next.palette.grey700 : theme.token.colorTextLabel}
        >
          RudderStack Account ID
        </BaseText>
        <BaseText color={isNext ? theme.token.next.palette.grey500 : theme.token.colorText}>
          {selectedDeleteAccountId}
        </BaseText>
      </Flex>
    </ModalStep>
  );
});
